
import Vue, { RenderContext } from "vue";
export default Vue.extend({
  name: "IsLoading",
  functional: true,
  props: {
    if: {
      type: Boolean,
      default: false
    }
  },
  render(h, { props, data, children }: RenderContext) {
    if (props.if) {
      return h("loading", {
        props: data.attrs
      });
    } else {
      return children;
    }
  }
});
